var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

var AbstractSegmentData = function(startVertex, endVertex){
    this.makeObservableTreeNode();

    this.startVertex = this.value("startVertex", true, lib_geometry.Coord.validator);
    this.endVertex = this.value("endVertex", true, lib_geometry.Coord.validator);

    if(startVertex !== undefined) this.startVertex(startVertex);
    if(endVertex !== undefined) this.endVertex(endVertex);
};
lib_core.mixin(AbstractSegmentData, lib_core.ObservableTreeNode);
lib_core.JsonParser.registerClass(AbstractSegmentData, "AbstractSegmentData");

module.exports = AbstractSegmentData;

AbstractSegmentData.prototype.getSegment = function() {
    return new lib_geometry.Segment(this.startVertex(), this.endVertex());
};
